export default {"src":"/statics/ecommerce/_next/static/media/byou-white.1a4ea37f.svg","height":14,"width":49,"blurWidth":0,"blurHeight":0};